// extracted by mini-css-extract-plugin
export default {"mobile":"pu3Efbet59EZZ6Eu44Rt"};